import React from 'react';
import { makeStyles } from '@mui/styles';
import {
  Container,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import {
  LinkedIn,
  GitHub
} from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(3, 0),
    marginTop: 'auto',
  },
  footerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      textAlign: 'center',
    },
  },
  name: {
    fontWeight: 700,
    color: theme.palette.primary.contrastText,
  },
  socialIcons: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  socialIcon: {
    color: theme.palette.primary.contrastText,
    '&:hover': {
      opacity: 0.8,
      transform: 'translateY(-2px)',
    },
    transition: 'all 0.3s ease',
  },
  copyright: {
    color: theme.palette.primary.contrastText,
    fontSize: '0.875rem',
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <Container maxWidth="lg">
        <Box className={classes.footerRow}>
          <Typography variant="h6" className={classes.name}>
            Ameet Toor
          </Typography>

          <Box className={classes.socialIcons}>
            <IconButton
              className={classes.socialIcon}
              href="https://linkedin.com/in/ameet-toor"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn Profile"
            >
              <LinkedIn />
            </IconButton>
            <IconButton
              className={classes.socialIcon}
              href="https://github.com/ameet2r"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub Profile"
            >
              <GitHub />
            </IconButton>
          </Box>

          <Typography variant="body2" className={classes.copyright}>
            &copy; {new Date().getFullYear()} Ameet Toor. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </footer>
  );
};

export default Footer;
